// @flow
import DefaultSettings from './DefaultSettings';

export default DefaultSettings;
